module.exports = __webpack_public_path__ + "img/ahorro_en_construccion.e252c860.png";